import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

const state = {
  token: '',//userId
  commonkey: "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC29pfMx8vWSgKxvn09P9S1W2k1lOMoID2hMMY+t8gtT5m5fC0Gi1D7Il64Jw294UCUFmaCB9X11qIWRf9DpxOR8iSxq1KCGwvrRHAjHcllp7Pfny/5hpMEEzEvlKzXu3ZAoITMOsle/ZUWJTdplG9XOJY1ukhpmr5ulhm/p11UhwIDAQAB",
  buy_px:[],//五档数据保存
  realTime:{}, //盘口数据
  tick:[],  //明细
  szList:[],//上证指数
  industry:[],
  lastPrice:'',//股票价格
  buyNumber:"",//最小可买股票
  amount_er:"",//input框输入的股数

}

export default new Vuex.Store({
  state,
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js